import { useEffect, useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { PageHeader, Panel } from "../components/Surface";
import { Button } from "../components/ui/Button";
import { inputClass } from "../components/FormKit";
import { listGroups, createGroup, type Group } from "../lib/groupchat";

export function Groups() {
  const [groups, setGroups] = useState<Group[]>([]);
  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState("");
  const [busy, setBusy] = useState(false);

  async function refresh() {
    setGroups((await listGroups()).groups);
  }
  useEffect(() => {
    refresh().finally(() => setLoading(false));
  }, []);

  async function create(e: FormEvent) {
    e.preventDefault();
    if (!title.trim()) return;
    setBusy(true);
    try {
      await createGroup(title);
      setTitle("");
      await refresh();
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mx-auto grid w-full max-w-2xl gap-6">
      <PageHeader title="Group chats" subtitle="Multi-party conversations — load discussions, team rooms, topic threads." />
      <Panel title="Start a group">
        <form className="flex gap-2" onSubmit={create}>
          <input className={inputClass} value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Group name (e.g. I-10 Reefer Run)" />
          <Button type="submit" disabled={busy || !title.trim()}>Create</Button>
        </form>
      </Panel>
      {loading ? (
        <p className="font-mono text-sm text-muted">Loading…</p>
      ) : groups.length === 0 ? (
        <p className="text-sm text-muted">No group chats yet. Create one above.</p>
      ) : (
        <div className="grid gap-2">
          {groups.map((g) => (
            <Link key={g.id} to={`/groups/${g.id}`} className="flex items-center justify-between gap-3 rounded-card border border-line bg-surface p-4 transition-colors hover:border-accent">
              <span className="font-bold">{g.title}</span>
              <span className="font-mono text-[11px] text-muted">{g.participant_count} · {g.kind}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
